import api from './api';

export const getLuckyChestConfig = () => api.get('/chests/lucky-chest-config');
